module.exports = __webpack_public_path__ + "static/media/Thesis_Map.dd692325.jpg";